<template>
    <div class="comMapBox">
        <div class="searchWrap">
            <div class="row1" style="justify-content: center;">
                <h2> {{  comname  }}</h2>
                
            </div>
            <div class="row1" style="justify-content: center;margin-top: -20px;">
                <h3> {{  location  }}</h3>
            </div>
        </div>
        <div class="content">
            <div id="map"></div>            
        </div>
        <div class="buttonBox">            
            <el-button type="danger"  @click="closeWin()" ><font-awesome-icon icon="times"  style="margin-right:5px;" />關閉</el-button>
        </div>         
    </div>
</template>

<script>
export default {
    components: { },
    data() {
        return {
            mapObj: {},
            comname: "",
            latitude: 24.9895,
            longitude: 121.5080,
            zoomDegree: 10,
            mapConfig: {
                tileLayerUrl: process.env.VUE_APP_TILE_LAYER_URL + '/data/v3/{z}/{x}/{y}.jpg',
                minZoom: 10,
                maxZoom: 16,
                defaultCenter: [24.9895, 121.5080],
                defaultZoom: 10,
                orangeIcon: null
            }
        }
    },
    methods: {
        closeWin() {
            window.close();
        },

        async groupMap() {
            var orangeIcon = new L.Icon({
                iconUrl: require('@/assets/markericons/marker-icon-2x-orange.png'),
                shadowUrl: require('@/assets/markericons/marker-shadow.png'),
                iconSize: [25, 41],
                iconAnchor: [12, 41],
                popupAnchor: [1, -34],
                shadowSize: [41, 41]
            });            

            // this.mapObj.remove();
            console.log(this.zoomDegree);

            this.mapObj = L.map('map',{ attributionControl: false}).setView([this.latitude, this.longitude], this.zoomDegree);

            L.tileLayer(process.env.VUE_APP_TILE_LAYER_URL + '/data/v3/{z}/{x}/{y}.jpg', {
                minZoom: 10,
                maxZoom: 16,
                attribution: ''
            }).addTo(this.mapObj);

            var markers = new L.markerClusterGroup().addTo(this.mapObj);

            // console.log(this.tabledata);

            var popMessage = '<h3>'+this.comname+'</h3><br />地址：'+this.location;           
            markers.addLayer(L.marker([this.latitude, this.longitude], {icon: orangeIcon}).bindPopup(popMessage));

            // 尤於地圖載入時, 會發生地圖無法顯示的問題, 所以延遲100ms後再請求地圖重繪
            setTimeout(()=>{this.mapObj.invalidateSize()}, 100);
        }
    },

    async mounted() {
        this.mapConfig.orangeIcon = new L.Icon({
            iconUrl: require('@/assets/markericons/marker-icon-2x-orange.png'),
            shadowUrl: require('@/assets/markericons/marker-shadow.png'),
            iconSize: [25, 41],
            iconAnchor: [12, 41],
            popupAnchor: [1, -34],
            shadowSize: [41, 41]
        });

        // 改成由外部傳入的Query
        this.latitude = this.$route.query.lat;
        this.longitude = this.$route.query.lng;
        this.comname = this.$route.query.branch;
        this.location = this.$route.query.loc;
        this.zoomDegree = 16;

        // 產生地圖
        await this.groupMap();
    },
    created() {

    }       
}
</script>

<style lang="scss" scoped>

    #map {
        width: 100%;
        height: 500px;
        border: 1px solid #000;
    }

    .comMapBox {
        
        background: linear-gradient(-135deg, #FFF 20%, #fff 50%, transparent 50%) center center / 100% 100%;
        display: flex;
        flex-direction: column;
        width: 100%;
        

        .dialogBox {
            display: flex;
            flex-direction: column;    
            width:90%;
            padding: 5px 5%;
            
            

            .upperBox {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;
                width: 100%;
                margin-top:20px; 
                margin-bottom: 20px;

                label {
                width: 100px;
                white-space: nowrap;
                margin-right: 10px;
                text-align: right;
                }
            }

            .lowerBox {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;
                width: 100%;
                margin-top:20px; 
                margin-bottom: 20px;

                .el-radio-group {
                    display: flex;
                    flex-wrap: wrap;
                    width: 100%;
                }
                .el-radio-group .el-radio {
                    flex: 0 0 25%;  /* 控制每行顯示四個選項 */
                    margin-top: 10px;
                }
            }

        }


        .searchWrap {
            display: flex;
            flex-direction: column;    
            justify-content: flex-start;
            padding: 0px 5%;
           
            
            .row1 {
                width:100%;
                display: flex;
                flex-direction: row;
                justify-content: flex-start;   
                
                .itemWrap {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: flex-start;  
                    
                    width: 100%;
                    margin-top:20px; 
                    margin-bottom: 20px;

                    label {
                        width: 100px;
                        white-space: nowrap;
                        margin-right: 10px;
                        margin-left: 10px;
                    //   text-align: right;
                    }
                }
            }

            .row2 {
                width:100%;
                display: flex;
                flex-direction: row;
                justify-content: flex-start;  
                
                .tagsClass  {
                    margin-right: 5px;
                }
            }    

        }
        .content {
            display: flex;
            flex-direction: columns;    
            justify-content: flex-start;
            padding: 0px 5%;
            .el-table {
                width: 100%;
                margin-top: 20px;
            }

        }
        .pageBox {
            display: flex;
            flex-direction: columns;    
            justify-content: flex-end;
            padding: 0px 5%;
        }  

        .goDetailPage {
            color: #0645ad;
            text-decoration: underline;
            cursor: pointer;
        }

    }

    
  .buttonBox {
    padding: 0 5%;
    display: flex;
    margin-top: 15px;
    justify-content: center;

  }
</style>
